import React, { useEffect, useState } from "react";

export default function InsightsAlerts({ apiUrl = "/api/ncd/insights" }) {
  const [insights, setInsights] = useState(null);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await fetch(apiUrl, { cache: "no-store" });
        if (!res.ok) throw new Error();
        const json = await res.json();
        if (!mounted) return;
        setInsights(json);
      } catch {
        // fallback mock data
        setInsights({
          alerts: [
            { type: "Low Coverage", message: "District 3, District 5", time: "2h ago" },
            { type: "Zero Reporting", message: "PHC-09, PHC-12", time: "5h ago" },
            { type: "High Dropout", message: "PHC-02", time: "8h ago" },
            { type: "Insight", message: "HTN control improved by 10% this quarter.", time: "10h ago" },
          ],
        });
      }
    })();
    return () => (mounted = false);
  }, [apiUrl]);

  const alerts = insights?.alerts || [];

  const getBadgeClass = (type) => {
    switch (type) {
      case "Low Coverage":
        return "bg-warning text-dark";
      case "Zero Reporting":
        return "bg-danger";
      case "High Dropout":
        return "bg-primary";
      case "Insight":
        return "bg-success";
      default:
        return "bg-secondary";
    }
  };

  return (
    <div className="card shadow-sm border-0 mt-0">
      <div className="card-body p-3">
        <h6 className="text-gray-800 font-semibold fs-6 mb-2">
          <i className="ni ni-bell-55 text-primary me-2"></i>
          Insights & Alerts
        </h6>

        {alerts.length === 0 ? (
          <div className="text-muted small">No alerts available</div>
        ) : (
          <div className="d-flex flex-column gap-2">
            {alerts.map((alert, index) => (
              <div
                key={index}
                className="border rounded-3 p-2 px-3 bg-light d-flex justify-content-between align-items-center shadow-sm-sm"
                style={{ fontSize: "0.85rem" }}
              >
                <div>
                  <span
                    className={`badge ${getBadgeClass(alert.type)} me-2`}
                    style={{ fontSize: "0.7rem" }}
                  >
                    {alert.type}
                  </span>
                  {alert.message}
                </div>
                <span className="text-muted small">{alert.time}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
